import { observer } from 'mobx-react-lite'
import { Box, Divider } from 'shared/ui'
import { Select } from 'shared/ui/Select/Select'
import { DoubleOptInSettingLayout } from 'pages/settings/pages/doubleOptIn/ui/doubleOptInSetting/DoubleOptInSettingLayout'
import { useNotificationsContext } from 'pages/settings/pages/notifications/context/notificationsContext'
import { ANALYTICS_FREQUENCY_ITEMS } from 'pages/settings/pages/notifications/constants/constants'
import styles from './styles.module.scss'

export const Options = observer(() => {
  const {
    analyticsReportSelectionValues,
    optionsLoading,
    ringEverywhere,
    toggleRingEverywhere,
    ringEverywhereLoading,
    notificationsEmail,
    toggleNotificationsEmail,
    analyticsReport,
    toggleAnalyticsReportActive,
    isShowAnalyticsSelect,
    setAnalyticsReportSelectedValues,
    closeAnalyticsReportDropdown,
    analyticsFrequencyText,
    isMemberOrObserver,
  } = useNotificationsContext()

  return (
    <Box padding='0 20px'>
      <DoubleOptInSettingLayout
        title={'Ring everywhere'}
        description={
          'Make the incoming ringtone play on your headset and computer speakers at the same time'
        }
        checked={ringEverywhere}
        onToggle={toggleRingEverywhere}
        disabled={ringEverywhereLoading}
        className={styles.toggleItem}
      />
      <Divider style={{ marginTop: '8px', marginBottom: '7px' }} />
      <DoubleOptInSettingLayout
        title={'Email'}
        description={'Receive notifications via email'}
        checked={notificationsEmail}
        onToggle={toggleNotificationsEmail}
        disabled={optionsLoading}
      />
      {!isMemberOrObserver && (
        <>
          <Divider style={{ marginTop: '8px', marginBottom: '7px' }} />
          <DoubleOptInSettingLayout
            title={'Activity report via email'}
            description={'Receive a breakdown of your messaging and calling analytics by email'}
            checked={analyticsReport.active}
            onToggle={toggleAnalyticsReportActive}
            disabled={optionsLoading}
            switcherLeftContent={(checked) =>
              checked && isShowAnalyticsSelect ? (
                <Select
                  type='multi'
                  text={analyticsFrequencyText}
                  values={analyticsReportSelectionValues}
                  onSelectValues={setAnalyticsReportSelectedValues}
                  items={ANALYTICS_FREQUENCY_ITEMS}
                  hideBadge
                  btnProps={{
                    typeBtn: 'stroke',
                    fontWeight: 400,
                    disabled: optionsLoading,
                  }}
                  dropdownProps={{
                    onClose: closeAnalyticsReportDropdown,
                    placement: 'bottom-end',
                    width: 200,
                    PopperProps: {
                      modifiers: [
                        {
                          name: 'offset',
                          options: {
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            offset: ({ reference }) => {
                              return [1, -reference.height - 4]
                            },
                          },
                        },
                      ],
                    },
                  }}
                />
              ) : null
            }
          />
        </>
      )}
    </Box>
  )
})
